import {createSlice} from "@reduxjs/toolkit";

const initialState = {
    selectUpdateCodeIdx: 0,
    selectCreateChildCodeIdx: 0,
};

const codeSlice = createSlice({
    name: 'code',
    initialState,
    reducers: {
        changeSelectUpdateCodeIdx(state, action) {
            state.selectUpdateCodeIdx = action.payload;
        },
        changeSelectCreateChildCodeIdx(state, action) {
            state.selectCreateChildCodeIdx = action.payload;
        },
     },
});

export const {
    changeSelectUpdateCodeIdx,
    changeSelectCreateChildCodeIdx,
} = codeSlice.actions;
export default codeSlice.reducer;